import { render } from "./AboutMe.vue?vue&type=template&id=30f9466e&ts=true"
import script from "./AboutMe.vue?vue&type=script&lang=ts"
export * from "./AboutMe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__